import template from './component.tpl.html';
import AlBoPreviewController from './controller';

angular
    .module('festzelt-os.modules.bo')
    .component('alBoPreview', {
        bindings: {
            rsvpId: '<',
            rsvpSeatplanElementId: '<',
            includeRseLinks: '<'
        },
        controller: AlBoPreviewController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/bo/components/al-bo-preview/component.js